/**
 * API COVERAGE — AuthController (/api/auth) [tenant authentication]
 *   POST /api/auth/login           → authApi.login
 *   POST /api/auth/refresh-token   → handled transparently by apiClient (401 interceptor)
 *   POST /api/auth/logout          → authApi.logout
 *   POST /api/auth/forgot-password → authApi.forgotPassword  (regenerates + emails a new password)
 *   POST /api/auth/verify-email    → authApi.verifyEmail
 *   GET  /api/auth/profile         → authApi.profile
 *   GET  /api/auth/branch-context  → authApi.branchContext  (tenant + accessible/default/current branches)
 *   POST /api/auth/switch-branch   → authApi.switchBranch   (persists current branch server-side)
 */
import { api } from '@/lib/apiClient';
import type {
  AuthResult,
  BranchContext,
  ForgotPasswordRequest,
  LoginRequest,
  ResetPasswordRequest,
  TenantProfile,
} from '@/types/auth';

export const authApi = {
  login: (body: LoginRequest) => api.post<AuthResult>('/auth/login', body),
  logout: (refreshToken: string) => api.post<unknown>('/auth/logout', { refreshToken }),
  profile: () => api.get<TenantProfile>('/auth/profile'),
  forgotPassword: (body: ForgotPasswordRequest) => api.post<unknown>('/auth/forgot-password', body),
  resetPassword: (body: ResetPasswordRequest) => api.post<unknown>('/auth/reset-password', body),
  verifyEmail: (body: { code: string; email: string; tenantCode?: string }) =>
    api.post<unknown>('/auth/verify-email', body),
  branchContext: () => api.get<BranchContext>('/auth/branch-context'),
  switchBranch: (branchId: number) => api.post<BranchContext>('/auth/switch-branch', { branchId }),
};
